<template>
  <svg
      class="plugin-cover"
      viewBox="0 0 640 360"
      preserveAspectRatio="xMidYMid slice"
      role="img"
      aria-hidden="true"
  >
    <defs>
      <linearGradient :id="gradientId" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" :stop-color="accent" stop-opacity=".18"/>
        <stop offset="1" stop-color="#ffffff" stop-opacity="0"/>
      </linearGradient>
      <pattern :id="gridId" width="32" height="32" patternUnits="userSpaceOnUse">
        <path d="M32 0H0V32" fill="none" :stroke="accent" stroke-opacity=".10"/>
      </pattern>
    </defs>

    <rect width="640" height="360" :fill="`url(#${gradientId})`"/>
    <rect width="640" height="360" :fill="`url(#${gridId})`"/>

    <!-- 易比图：双页 + 差异块 -->
    <template v-if="cover === 'yibitu'">
      <g transform="translate(118 64)">
        <rect width="238" height="228" rx="14" fill="#fff" stroke="#E2E8F0"/>
        <rect x="22" y="24" width="194" height="14" rx="7" fill="#EEF2F7"/>
        <rect x="22" y="52" width="88" height="8" rx="4" fill="#DDE4EF"/>
        <rect x="22" y="82" width="194" height="96" rx="8" fill="#F4F7FB"/>
        <circle cx="82" cy="118" r="22" :fill="accent" opacity=".22"/>
        <rect x="56" y="150" width="126" height="8" rx="4" fill="#DDE4EF"/>
        <rect x="126" y="118" width="54" height="17" rx="4" fill="#dc2626" opacity=".75"/>
      </g>
      <g transform="translate(286 88)">
        <rect width="238" height="228" rx="14" fill="#fff" :stroke="accent" stroke-opacity=".22"/>
        <rect x="22" y="24" width="194" height="14" rx="7" fill="#EEF2F7"/>
        <rect x="22" y="52" width="104" height="8" rx="4" fill="#DDE4EF"/>
        <rect x="22" y="82" width="194" height="96" rx="8" fill="#F4F7FB"/>
        <circle cx="82" cy="118" r="22" :fill="accent" opacity=".22"/>
        <rect x="56" y="150" width="126" height="8" rx="4" fill="#DDE4EF"/>
        <rect x="118" y="112" width="70" height="21" rx="4" fill="#dc2626" opacity=".75"/>
      </g>
      <rect class="scan" x="96" y="150" width="448" height="2" rx="1" :fill="accent" opacity=".55"/>
    </template>

    <!-- 易比图 V2：页堆 + 差异列表 -->
    <template v-else-if="cover === 'yibitu2'">
      <g transform="translate(92 58)">
        <rect x="22" y="20" width="210" height="236" rx="12" fill="#fff" stroke="#E2E8F0" opacity=".55"/>
        <rect x="12" y="10" width="210" height="236" rx="12" fill="#fff" stroke="#E2E8F0" opacity=".8"/>
        <rect width="210" height="236" rx="12" fill="#fff" :stroke="accent" stroke-opacity=".22"/>
        <rect x="18" y="18" width="174" height="10" rx="5" fill="#EEF2F7"/>
        <rect x="18" y="40" width="94" height="8" rx="4" fill="#DDE4EF"/>
        <rect x="18" y="64" width="174" height="118" rx="7" fill="#F4F7FB"/>
        <rect x="38" y="86" width="72" height="8" rx="4" fill="#DDE4EF"/>
        <rect x="38" y="104" width="120" height="8" rx="4" fill="#DDE4EF"/>
        <rect x="38" y="132" width="60" height="16" rx="4" fill="#dc2626" opacity=".7"/>
      </g>
      <g transform="translate(350 82)">
        <rect width="200" height="212" rx="14" fill="#fff" stroke="#E2E8F0"/>
        <rect x="18" y="18" width="164" height="10" rx="5" fill="#EEF2F7"/>
        <g fill="#F4F7FB">
          <rect x="18" y="44" width="164" height="32" rx="7"/>
          <rect x="18" y="84" width="164" height="32" rx="7"/>
          <rect x="18" y="124" width="164" height="32" rx="7"/>
          <rect x="18" y="164" width="164" height="32" rx="7"/>
        </g>
        <g :fill="accent" opacity=".8">
          <rect x="28" y="57" width="7" height="7" rx="2"/>
          <rect x="28" y="97" width="7" height="7" rx="2"/>
          <rect x="28" y="137" width="7" height="7" rx="2"/>
        </g>
        <g fill="#CBD5E1">
          <rect x="44" y="55" width="80" height="7" rx="3"/>
          <rect x="44" y="95" width="96" height="7" rx="3"/>
          <rect x="44" y="135" width="66" height="7" rx="3"/>
          <rect x="44" y="175" width="104" height="7" rx="3"/>
        </g>
      </g>
    </template>

    <!-- 批量对象替换 -->
    <template v-else-if="cover === 'ereplace'">
      <g>
        <rect
            v-for="(s, i) in replaceShapes"
            :key="i"
            :x="s.x"
            :y="s.y"
            width="74"
            height="62"
            rx="14"
            :fill="i === 0 ? '#dc2626' : (i < 4 ? accent : 'none')"
            :fill-opacity="i === 0 ? '.55' : (i < 4 ? '.16' : '0')"
            :stroke="i === 0 ? '#dc2626' : accent"
            :stroke-opacity="i === 0 ? '.9' : '.42'"
            stroke-width="1.6"
        />
      </g>
      <path d="M282 124h52" :stroke="accent" stroke-width="2" stroke-linecap="round" opacity=".5"/>
      <path d="M326 118l8 6-8 6" fill="none" :stroke="accent" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity=".8"/>
      <rect x="390" y="196" width="96" height="40" rx="12" fill="#fff" :stroke="accent" stroke-opacity=".28"/>
      <text x="438" y="221" text-anchor="middle" font-size="11" font-family="monospace" :fill="accent">NEW SHAPE</text>
    </template>

    <!-- 对象替换 -->
    <template v-else-if="cover === 'objreplacer'">
      <g transform="translate(142 82)">
        <rect width="180" height="160" rx="16" fill="#fff" :stroke="accent" stroke-opacity=".3"/>
        <text x="16" y="24" font-size="10" font-family="monospace" :fill="accent" opacity=".8">SOURCE</text>
        <g :fill="accent" opacity=".28">
          <circle v-for="(p, i) in anchorPoints" :key="i" :cx="p.x" :cy="p.y" r="3.4"/>
        </g>
      </g>
      <g transform="translate(350 116)">
        <rect width="120" height="104" rx="12" :fill="accent" fill-opacity=".08" :stroke="accent" stroke-opacity=".45"/>
        <text x="12" y="72" font-size="10" font-family="monospace" :fill="accent" opacity=".85">TARGET</text>
      </g>
      <path d="M330 168c22 0 22-36 38-36" fill="none" :stroke="accent" stroke-width="2" stroke-linecap="round" opacity=".55" stroke-dasharray="4 5"/>
      <path d="M362 126l8 6-8 6" fill="none" :stroke="accent" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity=".8"/>
      <rect x="124" y="248" width="392" height="26" rx="13" fill="#fff" stroke="#E2E8F0"/>
      <text x="320" y="265" text-anchor="middle" font-size="10" font-family="monospace" fill="#64748B">ANCHOR · SCALE · KEEP ORIGINAL</text>
    </template>

    <!-- 小帮条形码 -->
    <template v-else-if="cover === 'barcode'">
      <rect
          v-for="(b, i) in barcodeBars"
          :key="i"
          :x="b.x"
          :y="b.y"
          :width="b.w"
          :height="b.h"
          fill="#0F172A"
          opacity=".82"
      />
      <text x="320" y="232" text-anchor="middle" font-size="16" font-family="monospace" letter-spacing="5" fill="#0F172A" opacity=".78">
        6 978123 456789
      </text>
      <rect class="scan" x="128" y="142" width="384" height="2" rx="1" :fill="accent" opacity=".75"/>
      <g transform="translate(472 58)">
        <rect width="76" height="26" rx="13" :fill="accent" fill-opacity=".10" :stroke="accent" stroke-opacity=".18"/>
        <text x="38" y="17" text-anchor="middle" font-size="10" font-family="monospace" :fill="accent">SCAN</text>
      </g>
    </template>

    <!-- 色彩管理 -->
    <template v-else-if="cover === 'color'">
      <g transform="translate(126 74)">
        <rect
            v-for="(c, i) in cmykColors"
            :key="i"
            :x="i * 56"
            y="0"
            width="46"
            height="46"
            rx="12"
            :fill="c"
            :opacity="i === 3 ? '.86' : '.55'"
        />
        <rect x="0" y="66" width="222" height="156" rx="14" fill="#fff" stroke="#E2E8F0"/>
        <g v-for="i in 3" :key="i" :transform="`translate(16 ${84 + (i - 1) * 42})`">
          <rect width="18" height="18" rx="5" :fill="['#F472B6', '#2F5BFF', '#FACC15'][i - 1]" opacity=".6"/>
          <rect x="28" y="5" width="96" height="7" rx="3" fill="#DDE4EF"/>
          <text x="188" y="13" text-anchor="end" font-size="10" font-family="monospace" fill="#94A3B8">{{ 13 - i * 4 }}</text>
        </g>
      </g>
      <g transform="translate(386 82)">
        <rect width="144" height="164" rx="16" fill="#fff" :stroke="accent" stroke-opacity=".22"/>
        <text x="16" y="24" font-size="10" font-family="monospace" :fill="accent" opacity=".8">CMYK</text>
        <g font-family="monospace" font-size="11" fill="#64748B">
          <text x="16" y="58">C 0</text>
          <text x="16" y="84">M 82</text>
          <text x="16" y="110">Y 64</text>
          <text x="16" y="136">K 0</text>
        </g>
        <rect x="78" y="44" width="50" height="102" rx="8" :fill="accent" opacity=".13"/>
      </g>
    </template>

    <!-- 定制开发案例：等距盒型 + 刀模线 -->
    <template v-else-if="cover === 'case'">
      <g transform="translate(120 40)">
        <path
            d="M200 0L380 80V200L200 280L20 200V80L200 0Z"
            fill="#fff"
            :stroke="accent"
            stroke-opacity=".32"
            stroke-width="2"
        />
        <path d="M200 0V120L380 200M200 120L20 200M200 120V280" fill="none" :stroke="accent" stroke-opacity=".28" stroke-width="2"/>
        <path d="M200 0L380 80M200 0L20 80" fill="none" :stroke="accent" stroke-opacity=".16" stroke-width="2" stroke-dasharray="5 6"/>
        <circle cx="200" cy="0" r="4" :fill="accent" opacity=".6"/>
        <circle cx="380" cy="80" r="4" :fill="accent" opacity=".6"/>
        <circle cx="20" cy="80" r="4" :fill="accent" opacity=".6"/>
        <circle cx="200" cy="280" r="4" :fill="accent" opacity=".6"/>
        <text x="200" y="152" text-anchor="middle" font-size="12" font-family="monospace" :fill="accent" opacity=".75">CUSTOM</text>
        <text x="200" y="174" text-anchor="middle" font-size="10" font-family="monospace" :fill="accent" opacity=".45">PLUGIN CASE</text>
      </g>
      <g :stroke="accent" stroke-opacity=".35" stroke-width="2">
        <path d="M84 84h18M84 84v18" fill="none"/>
        <path d="M556 84h-18M556 84v18" fill="none"/>
        <path d="M84 276h18M84 276v-18" fill="none"/>
        <path d="M556 276h-18M556 276v-18" fill="none"/>
      </g>
    </template>
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  cover: { type: String, default: 'ereplace' },
  accent: { type: String, default: '#2F5BFF' }
})

const uid = 'pc' + Math.random().toString(36).slice(2, 8)
const gradientId = `f${uid}`
const gridId = `g${uid}`

const replaceShapes = [
  { x: 146, y: 82 }, { x: 256, y: 82 }, { x: 366, y: 82 },
  { x: 146, y: 184 }, { x: 256, y: 184 }, { x: 366, y: 184 }
]

const anchorPoints = computed(() => {
  const points = []
  for (let r = 0; r < 3; r++) {
    for (let c = 0; c < 3; c++) {
      points.push({ x: 30 + c * 60, y: 52 + r * 42 })
    }
  }
  return points
})

const barcodeBars = computed(() => {
  const widths = [5, 3, 7, 2, 4, 8, 3, 5, 2, 6, 3, 9, 4, 2, 6, 3, 8, 4, 2, 5, 7, 3, 6, 4, 8, 2, 5, 3, 7, 4, 6, 2, 8, 3, 5, 4]
  let x = 156
  return widths.map((w, i) => {
    const bar = { x, y: 86 + (i % 3), w, h: 110 - (i % 3) * 8 }
    x += w + (i % 4 === 0 ? 6 : 4)
    return bar
  })
})

const cmykColors = ['#22D3EE', '#F472B6', '#FACC15', '#0F172A']
</script>

<style scoped>
.plugin-cover {
  display: block;
  width: 100%;
  height: 100%;
}

.scan {
  animation: cover-scan 4.6s ease-in-out infinite;
}

@keyframes cover-scan {
  0%, 100% { transform: translateY(-6px); opacity: .45; }
  50% { transform: translateY(8px); opacity: .9; }
}

@media (prefers-reduced-motion: reduce) {
  .scan { animation: none; }
}
</style>
